import {
	AtestarCampoDeEstagio,
	CadastrarCampoDeEstagio,
	EmitirTCE,
	Inicio,
	ListaDeEstagios,
	ListarAtestesDeCampo,
	ListarCamposDeEstagio,
	ListarConcedentes,
	ListarConcedentesPropostos,
	ListarRequerimentos,
	Login,
	Logout,
} from './Paginas';

export const rotas = {
	'': Inicio,
	'/': Inicio,
	'#login': Login,
	'#logout': Logout,

	'#termo_novo': EmitirTCE,
	'#estagios_lista': ListaDeEstagios,

	'#requerimento_lista': ListarRequerimentos,

	'#proposta_concedente_lista': ListarConcedentesPropostos,
	'#concedente_lista': ListarConcedentes,

	'#campo_novo': CadastrarCampoDeEstagio,
	'#campo_lista': ListarCamposDeEstagio,

	'#ateste_novo': AtestarCampoDeEstagio,
	'#ateste_lista': ListarAtestesDeCampo,
};

export const menu = {
	Requerimento: {
		href: '/',
		dropdown: [
			{ href: '#requerimento_novo', label: 'Cadastrar' },
			{ href: '#requerimento_lista', label: 'Listar Requerimentos' },
		],
	},
	Concedentes: {
		href: '/',
		dropdown: [
			{ href: '#proposta_concedente_lista', label: 'Relação de Propostas' },
			{ href: '#concedente_lista', label: 'Relação de Concedentes' },
		],
	},
	'Campos de Estágio': {
		href: '/',
		dropdown: [
			{ href: '#campo_novo', label: 'Cadastrar Campo de Estágio' },
			{ href: '#campo_lista', label: 'Relação de Campos de Estágio' },
			{ href: '#ateste_novo', label: 'Cadastrar Ateste de Campo' },
			{ href: '#ateste_lista', label: 'Relação de Atestes de Campo' },
		],
	},
	Estágios: {
		href: '/',
		dropdown: [
			{ href: '#termo_novo', label: 'Emitir Novo Termo de Compromisso' },
			{ href: '#estagios_lista', label: 'Lista de Estágios' },
		],
	},
	Sair: {
		href: '#logout',
	},
};
